import { Container, Grid } from "@mui/material";

//styles
import './footer.scss';

//imgs
import mirasPermission from "../../../assets/imgs/miras.jpg";

function Miras() {
    return (
        <Container maxWidth='xl'>
            <Grid container>
                <Grid item xs={12}>
                    <img className="mirasPermission" src={mirasPermission} alt='mirasPermission'></img>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Miras;